import React, { useState } from "react";
import { motion } from "framer-motion";
import { Mail, Send, Check } from "lucide-react";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simulate API call
    setTimeout(() => {
      setIsSubscribed(true);
      setIsLoading(false);
      setEmail("");
    }, 1000);
  };

  if (isSubscribed) {
    return (
      <section className="py-16 bg-gradient-to-r from-spa-blue-600 to-spa-teal-600">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            className="text-center"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-4">
              <Check className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-white mb-2">
              Thank you for subscribing!
            </h3>
            <p className="text-spa-blue-100 max-w-md mx-auto">
              You&#39;ll receive our latest updates about hot springs, wellness
              tips, and exclusive offers.
            </p>
          </motion.div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-gradient-to-r from-spa-blue-600 to-spa-teal-600">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full mb-6">
            <Mail className="w-8 h-8 text-white" />
          </div>

          <h3 className="text-2xl sm:text-3xl font-serif font-bold text-white mb-4">
            HOT SPRINGS NEWSLETTER
          </h3>

          <p className="text-lg text-spa-blue-100 mb-8 max-w-2xl mx-auto">
            Get weekly hot springs discoveries & local wellness inspiration in
            your inbox
          </p>

          <motion.form
            onSubmit={handleSubmit}
            className="max-w-md mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="flex-1">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="w-full px-4 py-3 rounded-lg bg-white/90 backdrop-blur-sm border border-white/30 text-gray-800 placeholder-gray-500 focus:ring-2 focus:ring-white focus:border-transparent transition-all duration-200"
                />
              </div>
              <motion.button
                type="submit"
                disabled={isLoading}
                className="px-6 py-3 bg-white text-spa-blue-600 font-semibold rounded-lg hover:bg-spa-blue-50 focus:ring-2 focus:ring-white focus:outline-none transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                whileHover={{ scale: isLoading ? 1 : 1.05 }}
                whileTap={{ scale: isLoading ? 1 : 0.95 }}
              >
                {isLoading ? (
                  <div className="w-5 h-5 border-2 border-spa-blue-600 border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  <>
                    <span>Subscribe</span>
                    <Send className="w-4 h-4" />
                  </>
                )}
              </motion.button>
            </div>
          </motion.form>

          <motion.p
            className="text-sm text-spa-blue-200 mt-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            We respect your privacy. Unsubscribe at any time.
          </motion.p>

          {/* Benefits */}
          <motion.div
            className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            viewport={{ once: true }}
          >
            {[
              { icon: "🌟", text: "Exclusive offers & deals" },
              { icon: "📍", text: "New location discoveries" },
              { icon: "💆‍♀️", text: "Wellness tips & guides" },
            ].map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl mb-2">{benefit.icon}</div>
                <p className="text-sm text-spa-blue-100">{benefit.text}</p>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Newsletter;
